function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0.0742188 0.75 L 11.65625 16.285156 L 0 28.914062 L 2.625 28.914062 L 12.828125 17.855469 L 21.074219 28.914062 L 30 28.914062 L 17.765625 12.507812 L 28.613281 0.75 L 25.992188 0.75 L 16.597656 10.933594 L 9.003906 0.75 Z M 3.933594 2.6875 L 8.035156 2.6875 L 26.144531 26.972656 L 22.042969 26.972656 Z M 3.933594 2.6875 "
}));

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d37cebc9.svg";
export { ForwardRef as ReactComponent };